import { z } from 'zod';
// ── API envelope ──────────────────────────────────────────────────────────────
export const PaginationMetaSchema = z.object({
    page: z.number().int().positive(),
    limit: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    pages: z.number().int().nonnegative(),
});
export function ApiResponseSchema(dataSchema) {
    return z.object({
        success: z.literal(true),
        data: dataSchema,
        meta: PaginationMetaSchema.optional(),
    });
}
export const ApiErrorSchema = z.object({
    success: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
// ── Pagination query ──────────────────────────────────────────────────────────
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().optional(),
});
//# sourceMappingURL=common.js.map